//////////////////////
// Validations specific to the voi workflow
//////////////////////

import * as formatters from '../../utils/formatters';

export const lessThan256 = (val: string) => {
  if (!val) return val;
  if (val.length >= 256) return "Needs to be less than 256";
}

export const australianPostCode = (val: string) => {
  if (!val) return val;
  if (val.length !== 4 || isNaN(parseInt(val)) || val.match(/[a-z]/i)){
    return "Must be 4 digits"
  }
}

export const australianMobileNumber = (val: string) => {
  if (!val) return val;

  const error = "Invalid Australian number";

  val = formatters.removeSpacesAndHyphens(val);

  /** Allow 04|+614|+6104  (remaining digits) */
  const regex = /^(04|\+614|\+6104)[0-9]{8}$/g

  if ((val).match(regex) == null) {
    return error;
  }
}

export const pinCode = (val: string) => {
  /** `000000` | `000 000` */
  if (val && ((val.replace(/\s*/g, '')).match(/^([0-9]{6})$/g) == null)) {
    return "Must be 6 digits";
  }
}

export const nonNumericStrings = (val:string) => {
  if(!val) return val;
  if(val.match(/\d+/g)){
    return 'Must not contain numbers';
  }
}

export const name = (val: string, label: string): string => {
  if (!val) {
    return val;
  }

  if (val.match(/^[\sa-zA-Z\d'-]*$/) === null){
    return `Invalid ${label}`;
  }

  return '';
}

export const address = (val: string): string => {
  if (!val) {
    return val;
  }

  if (val.match(/^[\sa-zA-Z\d/(),'-]*$/) === null){
    return `Invalid address`;
  }

  return '';
}
